window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = '300';
window.lazySizesConfig.loadMode = 1;

// Initially enabling out of stock tooltip (requires Bootstrap jQuery)
$(document).ready(function() {
    $('[data-toggle="tooltip-filters-out-of-stock"]').tooltip({
        trigger: 'hover'
    });
});

// Initially enabling free upfront cost tooltip (requires Bootstrap jQuery)
$(document).ready(function() {
    $('[data-toggle="tooltip-filters-free-upfront-cost"]').tooltip({
        trigger: 'hover'
    });
});

document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementsByClassName('swiper-container').length > 0) {
        new Swiper('.swiper-container', swiperConfig.homepage);
    }

    if (document.querySelector('[data-category-links-swiper]')) {
        new Swiper('div[data-category-links-swiper]', swiperConfig.categoryLinkSwiper);
    }

    if (document.getElementsByClassName('tag-countdown').length > 0) {
        countdownClock.init('.tag-countdown');
    }

    smoothScrollToElementCopy('#product-ajax-response-holder', '.view-deals-anchor', '[data-tariff-container][data-tariff-product-layout]');

    if (document.getElementsByClassName('product-page-swiper-container').length > 0) {
        new Swiper('.product-page-swiper-container', swiperConfig.productPage);
    }

    if (document.querySelector('[data-product-family-swiper]')) {
        new Swiper('div[data-product-family-swiper]', swiperConfig.productPageFamily);
    }

    navigationMenu.init();

    setTileHeights('.tile-title', 5);
    setTileHeights('.tariff-wrapper', 5);
    setTileHeights('.tile');

    // Bootstrap tooltip initialization on deals-loaded event (requires jQuery)
    $(document).on('cdt.deals-loaded', function() {
        $('[data-toggle="tooltip"]').tooltip();
    });

    // Scroll to top button
    const scrollTopButtons = document.querySelectorAll('[data-scroll-top]');
    scrollTopButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    });
});

function setTileHeights(tileTariffClass, plusHeight) {
    // Set Tariff Section to be the same in all boxes
    let maxHeight = 0;
    const elements = document.querySelectorAll(tileTariffClass);

    elements.forEach(function(element) {
        element.style.minHeight = '';
        if (element.offsetHeight > maxHeight) {
            maxHeight = element.offsetHeight + (plusHeight || 0);
        }
    });

    elements.forEach(function(element) {
        element.style.minHeight = maxHeight + 'px';
    });
}

window.addEventListener('resize', function() {
    if (window.innerWidth < 768) {
        setTileHeights('.tile-height', 20);
    }
    setTileHeights('.tile-title', 5);
    toggleBackToTopTriggerVisibility('.back-to-top');
});

window.addEventListener('scroll', function() {
    toggleBackToTopTriggerVisibility('.back-to-top');
});

function toggleBackToTopTriggerVisibility(el) {
    const yPos = window.pageYOffset;
    const width = window.innerWidth;
    const elements = document.querySelectorAll(el);

    elements.forEach(function(element) {
        if (width >= 992) {
            if (yPos >= 1000) {
                element.style.display = 'block';
            }
            if (yPos < 1000) {
                element.style.display = 'none';
            }
        } else {
            element.style.display = 'none';
        }
    });
}

// Show more deals if javascript is enabled
$('.filter-state-paginating .more-deals-expander').show();

// eslint-disable-next-line no-unused-vars
function smoothScrollToElement(triggerEl, targetEl) {
    $(triggerEl).on('click', function() {
        $(targetEl).scrollTo();
    });
}

function smoothScrollToElementCopy(triggerEl, childEl, targetEl) {
    $(triggerEl).on('click', childEl, function() {
        $(targetEl).scrollTo();
    });
}

$.fn.scrollTo = function() {
    return this.each(function() {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 500);
    });
};

let swiperConfig = {
    homepage: {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        setWrapperSize: true,
        spaceBetween: 15,
        loop: false,
        keyboardControl: true,
        slidesPerView: 3.73,
        autoHeight: true,
        grabCursor: true,
        breakpoints: {
            1380: {
                slidesPerView: 3.23
            },
            1200: {
                slidesPerView: 3
            },
            1080: {
                slidesPerView: 2.8
            },
            992: {
                slidesPerView: 2.4
            },
            768: {
                slidesPerView: 1.9
            },
            560: {
                slidesPerView: 1.3
            },
            384: {
                slidesPerView: 1.2
            }
        }
    },
    categoryLinkSwiper: {
        slidesPerView: 5,
        simulateTouch: true,
        setWrapperSize: true,
        spaceBetween: 15,
        freeMode: true,
        keyboardControl: true,
        loop: false,
        breakpoints: {
            480: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 3.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 4.5,
                spaceBetween: 15,
            },
        }
    },
    productPage: {
        pagination: '.swiper-pagination',
        paginationClickable: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        simulateTouch: false,
        setWrapperSize: true,
        spaceBetween: 0,
        keyboardControl: true,
        loop: true
    },
    productPageFamily: {
        slidesPerView: 5,
        simulateTouch: true,
        setWrapperSize: true,
        spaceBetween: 15,
        freeMode: true,
        keyboardControl: true,
        loop: false,
        breakpoints: {
            480: {
                slidesPerView: 1.8,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 3.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 4.5,
                spaceBetween: 15,
            },
        }
    }
};

$(function() {
    let cookieLaw = $("div[data-banner-name='eucookielaw']");

    if (document.cookie.indexOf('eucookie') === -1) {
        cookieLaw.slideDown();
        let exdate = new Date();
        let expiredays = 365 * 10;
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = 'eucookie=eucookie;path=/' + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    } else {
        cookieLaw.remove();
    }

    cookieLaw.find('.btn-default').click(function() {
        cookieLaw.slideUp();
    });
});

$('.tariff-container').on('click', '[data-read-more-link] a', function(e) {
    e.preventDefault();
    $(this).parent().parent().find('[data-read-more-target]').removeClass('hidden');
    $(this).parent().remove();
});

function setUpCoverageCheckerModal(event) {
    let $buyButton = $(event.currentTarget);
    let $modal = $($buyButton.attr('data-coverage-checker'));
    $modal.find('[data-continue-to-basket]').attr('href', $buyButton.attr('href'));
    $modal.modal();
}

$('[data-coverage-checker].add-to-basket-btn').on('click', function(event) {
    event.preventDefault();
    setUpCoverageCheckerModal(event);
});

$('.tile [data-coverage-checker]').on('click', function(event) {
    event.preventDefault();
    setUpCoverageCheckerModal(event);
});

let starRatingHtmlTarget = $('[data-reviews-co-uk-summary-stars]');
let numberOfReviewsTarget = $('[data-reviews-co-uk-summary-reviews]');

if (starRatingHtmlTarget.length && numberOfReviewsTarget.length) {
    starRatingHtmlTarget.html($('.reviews-score-header .reviews-rating > span').html());
    numberOfReviewsTarget.text($('.reviews-score-header .reviews-total > span').text().replace('-', ''));
}

$(document).ready(function() {
    basketCounter.init();

    $('[data-toggle="html-tooltip"]').tooltip({
        placement: 'top',
        html: 'true'
    });

    let whitelistedCollapseHashes = ['#search', '#customerService', '#talkToUs'];

    if (whitelistedCollapseHashes.indexOf(window.location.hash) != -1) {
        let $element = $(window.location.hash);

        if ($element.length) {
            $element.collapse('show');

            if (window.location.hash == '#search') {
                $('body').addClass('header-search-active');
            }
        }
    }
});

$(document).ready(function() {
    $('.visible-xs-block.product-details-esim-info-box').on('click', function(event) {
        event.preventDefault();
        $('.modal').addClass('esim-popup-open-modal');
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const iframePlayers = new Map();
    let isApiReady = false;

    window.onYouTubeIframeAPIReady = () => {
        isApiReady = true;
    };

    window.initializeModalAndVideo = (iframeElement) => {
        if (!isApiReady) {
            return;
        }

        const modal = iframeElement.closest('.modal');
        if (modal) {
            iframePlayers.set(iframeElement, new YT.Player(iframeElement));
        }
    };

    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const modal = mutation.target;
                const iframe = modal.querySelector('iframe[src*="youtube.com/embed"]');

                if (iframe) {
                    if (!modal.classList.contains('show') && !modal.classList.contains('in')) {
                        const player = iframePlayers.get(iframe);
                        if (player && typeof player.pauseVideo === 'function') {
                            player.pauseVideo();
                        }
                    }
                }
            }
        }
    };

    const observer = new MutationObserver(observerCallback);

    const config = {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
    };
    observer.observe(document.body, config);

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});
